import { Component, Input } from '@angular/core';
import { TableChipConfig } from '@levelaccess/design-system';
import { TranslateService } from '../../translate/translate.service';
import { TrendChipUtility } from '../../utility/trend-chip.utility';

export interface ITrendConfig {
  currentValue: number;
  previousValue: number;
  isIncreaseImprovement: boolean;
  showNoChange?: boolean;
  noChangePrefix?: string;
}

@Component({
  selector: 'app-common-trend',
  templateUrl: './common-trend.component.html',
  styleUrls: ['./common-trend.component.scss'],
  standalone: false,
})
export class CommonTrendComponent {
  @Input() public config: ITrendConfig;

  constructor(private translateService: TranslateService) {}

  public get isPositiveTrend(): boolean {
    return this.variation > 0;
  }

  public get variation(): number {
    return TrendChipUtility.getVariation({
      currentValue: this.config?.currentValue,
      previousValue: this.config?.previousValue,
    });
  }

  public get absVariation(): number {
    return Math.abs(this.variation);
  }

  public get trendChipConfig(): TableChipConfig | null {
    return TrendChipUtility.getTrendChipConfig({
      currentValue: this.config?.currentValue,
      previousValue: this.config?.previousValue,
      isIncreaseImprovement: this.config?.isIncreaseImprovement,
      showNoChange: this.config?.showNoChange,
      noChangeText: this.translateService.instant('no_change'),
      noChangePrefix: this.config?.noChangePrefix,
    });
  }
}
